const notesOptions = [
    {
        range: 'mad',
        value: '1'
    },
    {
        range: 'mad',
        value: '2'
    },
    {
        range: 'sad',
        value: '3'
    },
    {
        range: 'sad',
        value: '4'
    },
    {
        range: 'sad',
        value: '5'
    },
    {
        range: 'sad',
        value: '6'
    },
    {
        range: 'glad',
        value: '7'
    },
    {
        range: 'glad',
        value: '8'
    },
    {
        range: 'glad',
        value: '9'
    },
    {
        range: 'glad',
        value: '10'
    }
]

export { notesOptions }
